export default __webpack_public_path__ + "static/media/facebook-inverted.2af2e46b.png";